export default __webpack_public_path__ + "static/media/encore.1ab2c820.jpg";